<template>
  <div class="contact">
    <h2>Contacte con nosotros</h2>
    <p>
      Puede ponerse en contacto con nosotros a través del siguiente formulario, o si lo desea a través de nuestro número de teléfono:
      <strong>664 871 207</strong>
      o en nuestro correo:
      <strong>info@versadainmobiliaria.com</strong>
    </p>
    <FormContact />
  </div>
</template>

<script>
import FormContact from "@/components/FormContact";

export default {
  name: "Contact",
  components: {
    FormContact
  },
  metaInfo() {
    return {
      title: "Contacta con nosotros " + process.env.VUE_APP_META_TITLE,
      meta: [
        {
          vmid: "description",
          name: "description",
          content: "Ponte en contacto con nosotros a través de nuestro número de teléfono y un agente le asesorará. No dude en consultar a Versada inmobiliaria, su inmobiliaria de confianza en Pontevedra"
        }
      ],
      link: [
        {
          rel: "canonical",
          href: process.env.VUE_APP_LINK + this.$route.path
        }
      ]
    };
  }
};
</script>